import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
  }

  onActivate() {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }
}
